import React from 'react';
import { useGame } from 'context/GameContext';
import Table from './table';

const Traits = () => {
  const { gameState } = useGame();
  const { party } = gameState;

  const { traits, progression, phase } = party;

  // Static traits data
  const traitsData = Object.keys(traits.list())
    .map(key => {
      const trait = traits.getTrait(key);
      if (!traits.isTraitVisible(key, phase)) return null;

      return {
        label: trait.label,
        value: trait.value
      };
    })
    .filter(e => e);

  // Dynamic path progression data
  const progressionData = progression.status();

  // Combine traits and progression data for rendering
  const combinedData = [...traitsData, ...progressionData];

  return combinedData.length ? <Table data={combinedData} summaryLabel={'Traits & Journeys'} /> : null;
};

export default Traits;
